var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterCountdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    rx: 1.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.42061C18.4422 6.66154 17.8478 6.82123 17.2281 6.89877C17.8656 6.524 18.3522 5.93508 18.5809 5.22523C17.9866 5.57415 17.3303 5.82061 16.6309 5.95815C16.0665 5.36646 15.2621 5 14.3846 5C12.6822 5 11.3116 6.36061 11.3116 8.02861C11.3116 8.26861 11.3322 8.49939 11.3828 8.71908C8.82625 8.59631 6.56406 7.38984 5.04438 5.552C4.77906 6.00523 4.62344 6.524 4.62344 7.08246C4.62344 8.13108 5.17187 9.06061 5.98937 9.59877C5.49531 9.58954 5.01063 9.44831 4.6 9.22584C4.6 9.23508 4.6 9.24708 4.6 9.25908C4.6 10.7305 5.66594 11.9526 7.06375 12.2342C6.81344 12.3015 6.54062 12.3338 6.2575 12.3338C6.06063 12.3338 5.86188 12.3228 5.67531 12.2822C6.07375 13.4812 7.20438 14.3628 8.54875 14.3914C7.5025 15.1972 6.17406 15.6828 4.73594 15.6828C4.48375 15.6828 4.24187 15.6717 4 15.6412C5.36219 16.5061 6.97656 17 8.7175 17C14.3763 17 17.47 12.3846 17.47 8.384C17.47 8.25016 17.4653 8.12092 17.4587 7.99261C18.0691 7.56615 18.5819 7.03354 19 6.42061Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterCountdown);
export default __webpack_public_path__ + "static/media/twitterCountdown.e57b9cb6.svg";
export { ForwardRef as ReactComponent };